module.exports = __webpack_public_path__ + "static/media/cancelled.082441a9.svg";